<script setup lang="ts">
const props = defineProps<{
  label?: string
  onReset: () => void
}>()

const defaultLabel = props.label || 'محتوایی یافت نشد'
</script>

<template>
    <div
        class="w-full flex flex-col items-center gap-7 rounded-xl bg-[#f5f7fa] text-[#1b325a] text-[21px] font-medium p-10 pt-12">
        <img src="/svg/close-svgrepo-com.svg" width="58" height="58" alt="close-icon" />
        <span>{{ defaultLabel }}</span>
        <Button @click="onReset" :isAdmin="true" variant="outline"
            class="w-1/2 lg:w-auto px-2  border-2  rounded-[10px]  h-11! py-0  ">
            <span class="flex items-center text-sm font-medium justify-center gap-2 ">
                <img width="22" src="/svg/return-svgrepo-com.svg" />
                تنظیم مجدد فیلتر
            </span>
        </Button>
    </div>
</template>
